var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCross = function SvgIconCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.273,
    y: 10.808,
    width: 24,
    height: 1.8,
    rx: 0.9,
    transform: "rotate(45 12.273 10.808)",
    fill: "#251447"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 1.8,
    rx: 0.9,
    transform: "scale(-1 1) rotate(45 -27.031 -28.36)",
    fill: "#251447"
  })));
};
export { SvgIconCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTIuMjczNCIgeT0iMTAuODA3NiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEuOCIgcng9IjAuOSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTIuMjczNCAxMC44MDc2KSIgZmlsbD0iIzI1MTQ0NyIvPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMS44IiByeD0iMC45IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC43MDcxMDcgMC43MDcxMDcgMC43MDcxMDcgMC43MDcxMDcgMjcuOTcwNyAxMC44MDc2KSIgZmlsbD0iIzI1MTQ0NyIvPgo8L3N2Zz4K";